import { render, staticRenderFns } from "./TransferConfigs.vue?vue&type=template&id=9d5ed7fa&"
import script from "./TransferConfigs.vue?vue&type=script&lang=js&"
export * from "./TransferConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports